// @ngInject
function Rms2ReportsApiService($q, $window, $cookies, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'reporting';

    return {
        getIntrastatReport: getIntrastatReport,
        getAfterSalesClaimReport: getAfterSalesClaimReport,
    };

    function getAfterSalesClaimReport(request) {
        var reportRequest = {
            fromDate: new Date(Date.UTC(request.fromDate.getFullYear(), request.fromDate.getMonth(), request.fromDate.getDate())),
            toDate: new Date(Date.UTC(request.toDate.getFullYear(), request.toDate.getMonth(), request.toDate.getDate(), 23, 59, 59, 0)),
        }

        var jsonData = JSON.stringify(reportRequest);

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint + '/afterSalesClaimReport', jsonData).then(function(response) {
            var blob = new Blob(["\uFEFF" + response.data.content], {type: 'data:text/csv;charset=utf-8'});
            var fileName = response.data.fileName;

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getIntrastatReport(request) {
        var reportRequest = {
            fromDeliveryDate: new Date(Date.UTC(request.fromDate.getFullYear(), request.fromDate.getMonth(), request.fromDate.getDate())),
            toDeliveryDate: new Date(Date.UTC(request.toDate.getFullYear(), request.toDate.getMonth(), request.toDate.getDate(), 23, 59, 59, 0)),
        }

        var jsonData = JSON.stringify(reportRequest);

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint + '/intrastatReport', jsonData).then(function(response) {
            var blob = new Blob(["\uFEFF" + response.data.content], {type: 'data:text/csv;charset=utf-8'});
            var fileName = response.data.fileName;

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('reports.api2', [])
    .factory('Rms2ReportsApiService', Rms2ReportsApiService);
